export default __webpack_public_path__ + "static/media/vegetarian.cfe3a813.png";